enum LabProcessingStatus {
    /** Lab result status is unknown. */
    None = 1,

    /** Lab result status is Preliminary. */
    Preliminary,

    /** Lab result status is Pending. */
    Pending,

    /** Lab result status is Cancelled. */
    Cancelled,

    /** Lab result status is Final. */
    Final,

    /** Lab result status is FinalCorrected. */
    FinalCorrected,

    /** Lab result status is PartialCorrected. */
    PartialCorrected,

    /** Lab result status is Partial. */
    Partial
}

export { LabProcessingStatus };
